/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InactiveCleanupSummaryDTO interface.
 */
export function instanceOfInactiveCleanupSummaryDTO(value) {
    return true;
}
export function InactiveCleanupSummaryDTOFromJSON(json) {
    return InactiveCleanupSummaryDTOFromJSONTyped(json, false);
}
export function InactiveCleanupSummaryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inactiveTotal': json['inactiveTotal'] == null ? undefined : json['inactiveTotal'],
        'inactiveInWindow': json['inactiveInWindow'] == null ? undefined : json['inactiveInWindow'],
        'eligibleTotal': json['eligibleTotal'] == null ? undefined : json['eligibleTotal'],
        'countByReason': json['countByReason'] == null ? undefined : json['countByReason'],
        'marketplaceInventoryCount': json['marketplaceInventoryCount'] == null ? undefined : json['marketplaceInventoryCount'],
        'reportSyncedAt': json['reportSyncedAt'] == null ? undefined : (new Date(json['reportSyncedAt'])),
        'inactiveTrackingSince': json['inactiveTrackingSince'] == null ? undefined : (new Date(json['inactiveTrackingSince'])),
        'activeRunId': json['activeRunId'] == null ? undefined : json['activeRunId'],
    };
}
export function InactiveCleanupSummaryDTOToJSON(json) {
    return InactiveCleanupSummaryDTOToJSONTyped(json, false);
}
export function InactiveCleanupSummaryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'inactiveTotal': value['inactiveTotal'],
        'inactiveInWindow': value['inactiveInWindow'],
        'eligibleTotal': value['eligibleTotal'],
        'countByReason': value['countByReason'],
        'marketplaceInventoryCount': value['marketplaceInventoryCount'],
        'reportSyncedAt': value['reportSyncedAt'] == null ? undefined : ((value['reportSyncedAt']).toISOString()),
        'inactiveTrackingSince': value['inactiveTrackingSince'] == null ? undefined : ((value['inactiveTrackingSince']).toISOString()),
        'activeRunId': value['activeRunId'],
    };
}
